'use strict';

import * as util from '../util/Common.js';
import {EventManager} from '../util/EventManager.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import * as iiifUtil from '../util/IIIFUtil.js';

const privateMap = util.createPrivateMapper();

function constructAnnoItem(annoData) {
  if (!annoData || !annoData.resource) {
    return;
  }
  const content = iiifUtil.weakDomParse(annoData.resource.chars);
  return content;
}

function constructGroup(annoList) {
  const pv = privateMap(this);
  if (!annoList) {
    return;
  }
  const annoDatas = [];
  const annoMap = {};
  pv.items[annoList.id] = annoMap;
  console.log('annoList', annoList.getDatas())
  util.each(annoList.getDatas(), (info) => {
    const itemEl = constructAnnoItem.call(this, info);
    if (!itemEl) {
      return;
    }
    const annoData = {
      info: info,
      domEl: itemEl
    };
    annoDatas.push(annoData);
    annoMap[info.id] = annoData;
  });
  if (annoDatas.length == 0) {
    return;
  }

  let result;
  let itemAppender;
  if (pv.flatStructure) {
    result = [];
    itemAppender = (annoData) => result.push(annoData);
  } else {
    const groupListItemEl = domUtil.createElement('li');
    const annoListEl = domUtil.createElement('ul');
    groupListItemEl.appendChild(annoListEl);
    result = groupListItemEl;
    itemAppender = (annoData) => annoListEl.appendChild(annoData.listItemEl);
  }
  let itemCreator;
  if (pv.itemCreator) {
    itemCreator = pv.itemCreator;
  } else {
    itemCreator = (annoData) => {
      const annoEl = annoData.domEl;
      const listItemEl = domUtil.createElement('li');
      const linkEl = domUtil.createElement('a');
      domUtil.setAttr(linkEl, 'href', '#');
      linkEl.appendChild(annoEl);
      listItemEl.appendChild(linkEl);
      annoData.listItemEl = listItemEl,
      annoData.linkEl = linkEl
    };
  }
  util.each(annoDatas, (annoData) => {
    itemCreator(annoData);
    const linkEl = annoData.linkEl;
    itemAppender(annoData);

    domUtil.addEventListener(linkEl, 'click', function(ev){
      ev.preventDefault();
      if (!pv.view) {
        return;
      }
      if (pv.focusedItem && pv.focusedItem.listId == annoList.id && pv.focusedItem.listId == annoData.info.id) {
        // already focused
        return;
      }
      pv.clickFocus = true;
      pv.view.focusAnnotation(annoList.id, annoData.info.id);
    });
    domUtil.addEventListener(linkEl, 'mouseover', function(ev){
      ev.preventDefault();
      if (!pv.view) {
        return;
      }
      const target = {};
      target[annoList.id] = [annoData.info.id];
      pv.view.selectAnnotations('hover', target);
    });
    domUtil.addEventListener(linkEl, 'mouseout', function(ev){
      ev.preventDefault();
      if (!pv.view) {
        return;
      }
      pv.view.selectAnnotations('hover');
    });

    pv.initializeAnnotation(annoData);
  });
  return result;
}

function handleAnnotationFocus(pv, ev){
  if (pv.focusedItem) {
    const annos = pv.items[pv.focusedItem.listId];
    if (annos) {
      const annoData = annos[pv.focusedItem.annotationId];
      if (annoData) {
        pv.setItemFocus(annoData, false);
      }
    }
  }
  const scroll = !pv.clickFocus;
  if (pv.clickFocus) {
    pv.clickFocus = false;
  }
  pv.focusedItem = null;
  const dtl = ev.detail;
  if (!dtl) {
    return;
  }
  const annos = pv.items[dtl.listId];
  let targetAnnoData;
  if (annos) {
    targetAnnoData = annos[dtl.annotationId];
  }
  if (!targetAnnoData) {
    return;
  }
  pv.focusedItem = Object.assign({}, dtl);
  pv.setItemFocus(targetAnnoData, true);
  if (!scroll) {
    return;
  }
  const offsetParent = targetAnnoData.listItemEl.offsetParent;
  if (!offsetParent) {
    return;
  }
  const containerHeight = domUtil.getHeight(offsetParent);
  const itemHeight = domUtil.getOffsetHeight(targetAnnoData.listItemEl);
  offsetParent.scrollTop = targetAnnoData.listItemEl.offsetTop - (containerHeight - itemHeight) / 2;
}

function handleAnnotationSelect(pv, ev){
  const dtl = ev.detail;
  if(!dtl){
    return;
  }
  if (!dtl.mode) {
    return;
  }
  const last = pv.lastSelectedItems[dtl.mode];
  if (last) {
    for (let k in last) {
      const annos = pv.items[k];
      util.each(last[k], (v) => {
        const annoData = annos[v];
        if (!annoData) {
          return;
        }
        pv.setItemSelection.call(this, dtl.mode, annoData, false);
      });
    }
  }
  pv.lastSelectedItems[dtl.mode] = dtl.targets;
  for (let k in dtl.targets) {
    const annos = pv. items[k];
    const annoIds = dtl.targets[k];
    util.each(annoIds, (annoId) => {
      const annoData = annos[annoId];
      if (!annoData) {
        return;
      }
      pv.setItemSelection.call(this, dtl.mode, annoData, true);
    })
  }
}

export class AnnotationListView extends UiComponent {
  constructor(domEl, options) {
    super(domEl);
    const pv = privateMap(this);
    pv.items = {};
    pv.initializeAnnotation = options.initializeAnnotation;
    pv.setItemSelection = options.setItemSelection;
    pv.setItemFocus = options.setItemFocus;
    pv.flatStructure = options.flatStructure;
    pv.itemCreator = options.itemCreator;
    pv.groupSuffixCreator = options.groupSuffixCreator;
    pv.lastSelectedItems = {};
    pv.focusedItem = null;
    pv.clickFocus = false;
    if (pv.flatStructure) {
      pv.groupListEl = domEl;
    } else {
      pv.groupListEl = domUtil.createElement('ul');
      domEl.appendChild(pv.groupListEl);
    }

    pv.annotationFocusHandler = (ev) => {
      handleAnnotationFocus.call(this, pv, ev);
    };
    pv.annotationchangeHandler = (ev) => {
      this.annotationListResources = ev.detail;
    };
    pv.annotationselectHandler = (ev) => {
      handleAnnotationSelect.call(this, pv, ev);
    };

    this.active = false;
  }

  set annotationListResources(annotationListResources) {
    const pv = privateMap(this);
    pv.annotationListResources = annotationListResources;
    domUtil.empty(pv.groupListEl);
    let hasData = false;
    let groupAppender;
    if (pv.flatStructure) {
      groupAppender = (g) => {
        if (g && g.length > 0) {
          hasData = true;
          for (let i of g) {
            pv.groupListEl.appendChild(i.listItemEl);
            if (i.suffixEl) {
              pv.groupListEl.appendChild(i.suffixEl);
            }
          }
        }
        if (pv.groupSuffixCreator) {
          const groupSuffixEl = pv.groupSuffixCreator()
          if (groupSuffixEl){
            pv.groupListEl.appendChild(groupSuffixEl)
          }
        }
      }
    } else {
      groupAppender = (g) => {
        if (g) {
          hasData = true;
          pv.groupListEl.appendChild(g);
        }
      }
    }
    util.each(pv.annotationListResources, (annoList) => {
      groupAppender(constructGroup.call(this, annoList));
    });
    this.active = hasData;
  }

  link(view) {
    const pv = privateMap(this);
    if (pv.view) {
      this.unlink();
    }
    pv.view = view;
    if (!pv.view) {
      return;
    }
    // pv.boxControl = view.renderer.boxControl;
    domUtil.addEventListener(pv.view.eventLayer, 'ui.annotationfocus', pv.annotationFocusHandler);
    domUtil.addEventListener(pv.view.eventLayer, 'ui.annotationchange', pv.annotationchangeHandler);
    domUtil.addEventListener(pv.view.eventLayer, 'ui.annotationselect', pv.annotationselectHandler);
    this.viewSize = view.size;
    pv.requestRender = function(){
      view.requestRender();
    };
  }

  unlink(){
    const pv = privateMap(this);
    if (!pv.view) {
      return
    }
    domUtil.removeEventListener(pv.view.eventLayer, 'ui.annotationfocus', pv.annotationFocusHandler);
    domUtil.removeEventListener(pv.view.eventLayer, 'ui.annotationchange', pv.annotationchangeHandler);
    domUtil.removeEventListener(pv.view.eventLayer, 'ui.annotationselect', pv.annotationselectHandler);
    pv.requestRender = function(){};
    pv.view = null;
    this.active = false;
  }
}